import React, {useRef} from 'react';
import './App.css';
import Grid from '@mui/material/Grid2';
import FormData from './modules/components/FormData';
import {ContextProvider} from './modules/ContextProvider';
import './i18n/i18n';
import Theme from './modules/themes/Theme';
import {Box, useMediaQuery, useTheme} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(129, 83, 253)',
        }
    }
});

function App() {
    return (
        <ContextProvider>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Studio />
                </LocalizationProvider>
            </ThemeProvider>
        </ContextProvider>
    );
}

function Studio()  {
    const refObject = useRef<HTMLDivElement>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container>
            <Grid size={{xs: 12, sm: 12, md: 8, lg: 8}}>
                <Box
                    display={isMobile? 'block' : 'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    marginTop={0}
                    height={isMobile ? 'auto' :  '100%'}
                >
                    <Theme refObject={refObject} size={isMobile ? 'mobile' : 'desktop'} />
                </Box>
            </Grid>
            <Grid size={{xs: 12, sm: 12, md: 4, lg: 4}} paddingTop={5}>
                <FormData refObject={refObject} />
            </Grid>
        </Grid>
    )
}

export default App;
